import { createFileRoute } from "@tanstack/react-router";
import ResetPasswordPage from "@/components/auth/ResetPasswordPage";

export const Route = createFileRoute("/auth/_authLayout/reset-password")({
  component: ResetPasswordPage,
  head: () => ({ meta: [{ title: "Reset Password | Lutely" }] }),
});
